// import styled from 'styled-components';
import styled from "@emotion/styled";

type PagiNationSectionTypes = {
	active?: boolean;
  isMobile?: boolean;
};

export const PagiNationSection = styled.div<PagiNationSectionTypes>`
  text-align: center;
  display: flex;
  justify-content: center;
  ul {
    display: flex;
    li {
      padding: ${(props: any) => props.isMobile ? '0 2px' : '0 6px'};
      a {
        display: inline-block;
        width: ${(props: any) => props.isMobile ? '24px' : '40px'};
        height: ${(props: any) => props.isMobile ? '24px' : '40px'};
        line-height: ${(props: any) => props.isMobile ? '24px' : '40px'};
        border-radius: 100px;
        font-size: ${(props: any) => props.isMobile ? props.theme.fontSizes['xl'] : props.theme.fontSizes['2xl']};
        font-weight: bold;
      }

      &.selected {
        a {
          background-color: ${(props: any) => props.theme.colors.b.dgr};
          color: ${(props: any) => props.theme.colors.b.wh};
        }
      }
    }
  }
`;
